export enum InvitationStatus {
  WaitingRegistration = 'waiting-registration',
  PendingResponse = 'pending-response',
  Accepted = 'accepted',
  Declined = 'declined',
  Canceled = 'canceled'
}
